module.exports = __webpack_public_path__ + "static/img/1_3.5b9eb53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/1_3.png
// module id = JKv+
// module chunks = 44